<div class="field-dashboard-main-container">
  <div class="tab-navigation-container">
    <div class="tabs-left">
      <div class="flex items-center gap-3">
        <a class="tab-link" routerLink="analysis" routerLinkActive="active-tab">Field Analysis</a>
        <!-- The integration status "?" button sits in the Field Details card, beside the field outline
             (field-analysis.component.html). Its state and the drawer stay on this page. -->
      </div>
      <!-- <a class="tab-link" routerLink="cost-breakdown" routerLinkActive="active-tab">Cost Breakdown</a> -->
    </div>
    <!-- The UI kit's dropdown and date pickers, as on Pin Manager (Heinrich, 28/10/2026). The season
         label sits beside its dropdown like the date pickers' labels, so the row reads the same. -->
    <div class="date-range-right">
      <div class="flex items-center gap-2">
        <span class="text-[11px] font-bold text-gray-800 uppercase tracking-wide whitespace-nowrap" aria-hidden="true">Season</span>
        <ui-dropdown class="block w-[130px]" placeholder="Season" [options]="seasonOptions" [value]="selectedSeason"
                     (valueChange)="onSeasonPicked($event)"></ui-dropdown>
      </div>
      <ui-datepicker label="START DATE" [value]="startIso" (valueChange)="onStartPicked($event)"></ui-datepicker>
      <ui-datepicker label="END DATE" [value]="endIso" (valueChange)="onEndPicked($event)"></ui-datepicker>
    </div>
  </div>
  <router-outlet></router-outlet>
  <app-integration-drawer *ngIf="sg" [open]="drawerOpen()" [status]="integrationStatus()"
                          [loading]="integrationStatusLoading()" [failed]="integrationStatusFailed()"
                          (closed)="closeDrawer()" (retry)="retryIntegrationStatus()"></app-integration-drawer>
</div>
